import { useCallback } from 'react';
import moment from 'moment';

import { useShowModal } from '../../../actions/modal';
import { NotificationTypes, usePushNotification } from '../../../actions/notifications';
import { getTitle } from '../../../service/utils';
import { usePoints } from './usePoints';

export const useHandler = (legId, toggleUpdate) => {
    const showModal = useShowModal();
    const pushNotification = usePushNotification();
    const getCurrentPoint = usePoints(legId);

    const showCheckModal = useCallback(
        ({ popupType }) => {
            const { point, pos } = getCurrentPoint(moment.utc().toISOString());
            const { route, rnt } = point;
            const title = getTitle(popupType, { route, rnt });
            showModal(popupType, {
                toggleUpdate,
                title: title,
                pos: pos,
                point: point,
                isNewPoint: true,
            });
        },
        [getCurrentPoint]
    );

    return useCallback(
        (popupType, legId) => {
            pushNotification({
                variant: NotificationTypes.ALERT,
                message: popupType,
                callback: () =>
                    showCheckModal({
                        popupType,
                    }),
                onDismiss: toggleUpdate,
                props: { legId },
            });
        },
        [showCheckModal]
    );
};
